import { ModalLayout } from '@starsoft/common/components';
import { useSearchParams, useTranslation } from '@starsoft/common/hooks';
import UserPhoneNumberFormRenderer from './Form/Renderer';
import { CommonModalsKey } from '@starsoft/common/enums';

/**
 * UserPhoneNumberModal Component
 * This component is responsible for rendering a modal for user phone number actions.
 * It uses the ModalLayout component to display the modal and includes a form renderer for phone number actions.
 *
 * @returns {JSX.Element} The rendered user phone number modal component.
 *
 * @example
 * // Usage example:
 * <UserPhoneNumberModal />
 */
export function UserPhoneNumberModal() {
  // Translation hook for the 'account' namespace
  const { t } = useTranslation('account');

  // Hook to get search parameters from the URL
  const search: URLSearchParams = useSearchParams();

  // Get the phone number ID from the search parameters
  const phoneNumberId: string | undefined = search.get('phone-number-id');

  // Render the modal layout with the appropriate title and form renderer
  return (
    <ModalLayout
      title={t(!!phoneNumberId ? 'verify_phone_number' : 'create_phone_number')}
      modal={CommonModalsKey.UserPhoneNumber}
      fitContent
      smallMobilePadding
    >
      <UserPhoneNumberFormRenderer />
    </ModalLayout>
  );
}
